export default __webpack_public_path__ + "static/media/01__o_preview_3.7da27280.jpg";